import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import Select from "react-select";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { WebEngage, GA } from "../../../integrations";
import { PAGE_TYPE } from "../../../constants";
import { fetchConstituencyDetail, fetchCandidatesList } from "../../../api";
import styles from "./styles.m.css";
import SixStory6s from "../../rows/six-stories";
import Carousel from "../../atoms/carousel";
import { Icon } from "../../atoms/icon";
import Iframe from "react-iframe";
import Cookies from "universal-cookie";
import ConstituencySearchBar from "../../atoms/constituency-searchbar";
import assetify from "@quintype/framework/assetify";
import loader from "../../../../assets/images/loader.gif";
import { checkQueryString } from "../../utils/utils";
import { VikatanAsidebar } from "../../rows/ad-free";
const cookies = new Cookies();

class AutoSelectComponent extends React.Component {
  logChange = val => {
    const { SelectedValue } = this.props;
    SelectedValue(val.value);
  };

  render() {
    const { options, className } = this.props;
    return <Select className={styles[className]} options={options} onChange={this.logChange} />;
  }
}

AutoSelectComponent.propTypes = {
  options: PropTypes.array,
  SelectedValue: PropTypes.func,
  className: PropTypes.string
};

const ConstituencyPage = ({ data }) => {
  const [constituency, setConstituency] = useState([]);
  const [candidatesList, setCandidatesList] = useState([]);
  const slug = get(data, ["slug"], "");
  const [tabIndex, setTabIndex] = useState(0);
  useEffect(() => {
    fetchConstituencyDetail(slug)
      .then(res => {
        const resData = get(res, ["data", "items"]);
        setConstituency(resData);
        const params = checkQueryString("view");
        let prachaikalTap = params || 0;
        setTabIndex(Number(prachaikalTap));
      })
      .catch(console.error);

    fetchCandidatesList(slug)
      .then(res => {
        const resData = get(res, ["data", "items"]);
        setCandidatesList(resData);
      })
      .catch(console.error);
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.CONSTITUENCY_PAGE, { collection: data.collection });
  }, []);

  const entries = Object.entries(candidatesList);

  const slidesWithClasses =
    entries !== 0 &&
    entries.map((slide, idx) => {
      return (
        <div className={styles["box-div"]} key={"slide-" + idx}>
          <div className={styles["title"]}>
            <h1>{slide[1].team_name}</h1>
          </div>
          <div className={styles["other-img"]}>
            {slide[1].star_candidate !== 0 ? <Icon type="star" className={styles["star-icon"]} /> : ""}
            <img
              // eslint-disable-next-line max-len
              src={`${slide[1].candidate_image}`}
              className={styles["mem-img"]}
            />
          </div>
          <h1>
            {slide[1].candidate_name} <span>({slide[1].party_name})</span>
          </h1>
        </div>
      );
    });

  const title = get(constituency, ["area"], null);
  const pic = get(constituency, ["area_image"], null);
  let description = get(constituency, ["description"], "");
  description = description.replace(/(<([^>]+)>)/gi, "");
  const femaleVoters = get(constituency, ["female_voters"], null);
  const maleVoters = get(constituency, ["male_voters"], null);
  const othersVoters = get(constituency, ["others"], null);
  const MlaPic = get(constituency, ["current_mla_image"], null);
  const ennaSeitharMla = get(constituency, ["enna_seithar_mla"], null);
  const currentMla = get(constituency, ["current_mla"], null);
  const currentMlaParty = get(constituency, ["current_mla_party"], null);
  const districtName = get(constituency, ["district_name"], null);
  const storyLink = get(constituency, ["article_url"], null);
  const totalPeople = parseInt(femaleVoters) + parseInt(maleVoters) + parseInt(othersVoters);
  const thumb = get(constituency, ["current_mla_thumbs"], null);
  const collection = get(data, ["collection", "items", 0], []);
  const constituencySlug = get(constituency, ["thokkuthi_slug"], null);
  const partyId = get(constituency, ["party_id"], null);

  const vetpalarkalOption = entries.length !== 0 && (
    <div className={styles["other-members-wrapper"]}>
      <h2>{title} வேட்பாளர்கள் </h2>
      <div className={styles["other-members-slider"]}>
        <Carousel
          className={`${styles["other-members-slider"]}`}
          options={{
            autoplay: 3000,
            type: "carousel",
            perView: 4,
            gap: 80,
            breakpoints: {
              320: {
                perView: 1.5,
                gap: 10
              },
              767: {
                perView: 1.5,
                gap: 10
              },
              991: {
                perView: 4,
                gap: 40
              }
            }
          }}
          renderCenterLeftControls={({ previousSlide }) => {
            return null;
          }}
          renderCenterRightControls={({ nextSlide }) => {
            return null;
          }}
          renderBottomCenterControls={({ currentSlide, goToSlide }) => {
            return null;
          }}
        >
          {slidesWithClasses}
        </Carousel>
      </div>
    </div>
  );
  const firstOption = (
    <div>
      <div className={`${styles["consti-first-grid"]}`}>
        <div className={`${styles["consti-main-sec"]}`}>
          <div>{pic && <img src={pic} />}</div>
          <div className={`${styles["consti-dist-sec"]}`}>
            <div className={`${styles["consti-dist-grid"]}`}>
              <span className={`${styles["consti-dist-label"]}`}>மாவட்டம்</span>
              <span className={`${styles["consti-dist-name"]}`}>{districtName}</span>
            </div>
            <div className={`${styles["consti-dist-grid"]}`}>
              <span className={`${styles["consti-dist-label"]}`}>சட்டமன்றத் தொகுதி</span>
              <span className={`${styles["consti-dist-name"]}`}>{title}</span>
            </div>
          </div>
        </div>
        <div className={`${styles["consti-sec-sec"]}`}>
          <h1>மொத்த வாக்காளர்கள் {totalPeople}</h1>
          <div className={`${styles["people-count"]}`}>
            <div className={`${styles["votecount"]}`}>
              <img src="https://media.vikatan.com/vikatan/2021-03/2067d6de-28c2-4f63-a294-cedf4672f9a5/male.png" />
              <h2>ஆண்கள்</h2>
              <div>{maleVoters}</div>
            </div>
            <div className={`${styles["votecount"]}`}>
              <img src="https://media.vikatan.com/vikatan/2021-03/3b51e7f1-9fec-47d6-8985-ce84bc4fada1/female.png" />
              <h2>பெண்கள்</h2>
              <div>{femaleVoters}</div>
            </div>
            <div className={`${styles["votecount"]}`}>
              <img src="https://media.vikatan.com/vikatan/2021-03/c4f95fdb-d2db-4c72-b184-e4e1af726574/transgender.png" />
              <h2>மூ.பாலினத்தவர்</h2>
              <div>{othersVoters}</div>
            </div>
          </div>
          <div className={`${styles["mla-detail"]}`}>
            <img src={MlaPic} />
            <div className={`${styles["mla-question"]}`}>
              <div>
                <h2>என்ன செய்தார் எம்.எல்.ஏ?</h2>
                <img src={thumb} width="80" />
              </div>
              {storyLink && (
                <Link
                  aria-label={`${"Read full story: "}`}
                  href={`${storyLink}?pfrom=constituency-page`}
                  externalLink={storyLink}
                  className={`${styles["read-more-link"]}`}
                >
                  மேலும் படிக்க
                </Link>
              )}
            </div>
          </div>
          <div className={`${styles["mla-name"]}`}>
            {currentMla} <span>{currentMlaParty}</span>
          </div>
        </div>
      </div>
      {vetpalarkalOption}
      {description && (
        <div>
          <h3 className={styles["election-title"]}>தொகுதி அலசல்</h3>
          <p>{description}</p>
        </div>
      )}
      {ennaSeitharMla && (
        <div>
          <h3 className={styles["election-title"]}>என்ன செய்தார் எம்.எல்.ஏ?</h3>
          <p>{ennaSeitharMla}</p>
          {storyLink && (
            <div className={styles["story-link-bar"]}>
              <div>சொன்னதைச் செய்தாரா எம்.எல்.ஏ?</div>
              <Link
                aria-label={`${"Read full story: "}`}
                href={`${storyLink}?pfrom=constituency-page`}
                externalLink={storyLink}
                className={`${styles["link"]}`}
              >
                மேலும் படிக்க
              </Link>
            </div>
          )}
        </div>
      )}
      <div className={styles["third-op"]}>
        <SixStory6s collection={collection} />
      </div>
    </div>
  );

  const staticUrl = "https://special.vikatan.com/election/constituency/problems";
  const secondOption = (
    <div>
      <Iframe
        frameBorder="0"
        className={styles["iframe-outer"]}
        src={`${staticUrl}/index.php?constituency_id=${partyId}&survierId=${cookies.get("thinmint")}`}
      />
    </div>
  );

  const handleTabs = index => {
    setTabIndex(index);
    window.history.replaceState({}, "", `?view=${index}`);
  };

  return (
    <React.Fragment>
      <div className={`main-page styles-m__base__2vtxy js-story-main-container ${styles["base-class"]}`}>
        <div />
        <div className="page-content infinity-page">
          <div className={`container ${styles["story-grid"]}`}>
            <div className={`${styles["main-container"]}`}>
              <ul className={styles["breadcrumb-wrapper"]}>
                <li className={`${styles["breadcrumb"]}`}>
                  <Link aria-label={`breadcrumb`} href="/">
                    முகப்பு
                  </Link>
                </li>
                <li className={`${styles["breadcrumb"]}`}>
                  <Link aria-label={`breadcrumb`} href="/election-2021">
                    தமிழ்நாடு சட்டசபை தேர்தல்
                  </Link>
                </li>
                <li className={`${styles["breadcrumb"]}`}>
                  <Link
                    aria-label={`இங்கு க்ளிக் செய்க`}
                    // eslint-disable-next-line max-len
                    href={`/election-2021/constituency/${constituencySlug}-assembly-constituency-elections-2021-updates`}
                  >
                    {title}
                  </Link>
                </li>
              </ul>
              <div className={styles["districk-dropdown"]}>
                <ConstituencySearchBar />
                <h1>{title}</h1>
              </div>
              <Tabs selectedIndex={tabIndex} onSelect={index => handleTabs(index)}>
                <TabList>
                  <Tab>தொகுதி கண்ணோட்டம்</Tab>
                  <Tab>பிரச்னைகள்</Tab>
                  <Tab>வேட்பாளர்கள்</Tab>
                </TabList>

                <TabPanel>
                  {title ? firstOption : <img alt="Vikatan" src={assetify(loader)} className={styles["loader"]} />}
                </TabPanel>
                <TabPanel>{secondOption}</TabPanel>
                <TabPanel>
                  <h2 className={styles["third-tab-details"]}>{slidesWithClasses}</h2>
                </TabPanel>
              </Tabs>
            </div>
            <aside className={styles.sidebar}>
              <VikatanAsidebar />
            </aside>
          </div>
        </div>

        <div />
      </div>
    </React.Fragment>
  );
};
export { ConstituencyPage };

ConstituencyPage.propTypes = {
  data: PropTypes.shape()
};
